import { useFeatureFlag } from "contexts/FeatureFlagContext";
import { useGlobalSettingsContext } from "contexts/GlobalSettingsContext";
import { useMemo } from "react";
import { difference, filter } from "utils/lodashUtils";
import {
  FINDING_ACTIONS_FLAGS,
  FINDING_STATUS,
} from "views/Findings/Constants";

const STATUS: string[] = [
  FINDING_STATUS.OPEN,
  FINDING_STATUS.TRIAGE,
  FINDING_STATUS.CONFIRMED,
  FINDING_STATUS.IN_PROGRESS,
  FINDING_STATUS.ACCEPT_RISK,
  FINDING_STATUS.FALSE_POSITIVE,
  FINDING_STATUS.SUPPRESSED,
  FINDING_STATUS.CONTROLLED,
  FINDING_STATUS.MITIGATED,
];

export default function useEnabledFindingStatus(): string[] {
  //@ts-ignore
  const { disabledFindingStatus } = useGlobalSettingsContext();
  const featureFlags = useFeatureFlag();

  const enabledFindingStatus = useMemo(() => {
    const statusArray = filter(STATUS, (status) =>
      //@ts-ignore
      FINDING_ACTIONS_FLAGS[status]
        ? //@ts-ignore
          featureFlags[FINDING_ACTIONS_FLAGS[status]]
        : true,
    );

    return difference(statusArray, disabledFindingStatus);
  }, [disabledFindingStatus, featureFlags]);

  return enabledFindingStatus as string[];
}
